(function() {
    const form = document.querySelector(".header__top-column form");
    let isFormActive = false;
    let html = document.querySelector('html');
    let input = null;
    let button = null;
    let buttonMobile = null;

    if(form) {
        form.setAttribute("role", "search");

        input = form.querySelector("input");
        button = form.querySelector("button");
        buttonMobile = document.querySelector(".header__top-button--mobile");

        button.addEventListener("click", handleClick);
        buttonMobile ? buttonMobile.addEventListener("click", handleClick) : null;
        input.addEventListener("blur", handleBlur);
        input.addEventListener("focus", handleFocus);
    }

    function handleClick(e) {
        e.stopPropagation();

        if(e.target != buttonMobile) {
            if(isFormActive) {
                form.submit();
            } else {
                isFormActive = true;
                input.setAttribute("aria-hidden", !isFormActive);
                form.classList.add("active");
                input.focus();
                document.querySelector(".header__bottom-list-item").classList.remove("active");
            }
        } else {
            form.classList.toggle("active");
            html.classList.remove("menu_open");
        }
    }

    function handleBlur(e) {
        if(e.relatedTarget !== button) {
            form.classList.remove("active");
            form.classList.remove("has-focus");
            isFormActive = false;
            input.setAttribute("aria-hidden", !isFormActive);
        }
    }

    function handleFocus(e) {
        form.classList.add("has-focus");
    }
}());